import { Page } from '../page';
import { Factory } from './factory';
import { Image } from '../image';
import { ApplicationStateService } from '../../services/application-state.service';

export class PageFactory implements Factory<Page> {

    constructor(private applicationStateService: ApplicationStateService) {
    }

    buildFromFactory(): Page {
        return undefined;
    }

    buildFromObject(jsonObject: any): Page {
        const pageCacheKey: string = this.applicationStateService.bookConfig.pageCacheKey;

        const page = new Page();
        page.id = jsonObject.id;
        page.index = jsonObject.index;
        page.readSpeakerEnabled = jsonObject.readSpeakerEnabled;
        page.selections = jsonObject.selections;

        // Append page cache key to every url
        const imageUrl = `${jsonObject.image.url}?${pageCacheKey}`;
        page.image = Image.createImage(imageUrl, jsonObject.image.width, jsonObject.image.height);

        const zoomImageUrl = `${jsonObject.zoomImage.url}?${pageCacheKey}`;
        page.zoomImage = Image.createImage(zoomImageUrl, jsonObject.zoomImage.width, jsonObject.zoomImage.height);

        const thumbnailImageUrl = `${jsonObject.thumbnailImage.url}?${pageCacheKey}`;
        page.thumbnailImage = Image.createImage(thumbnailImageUrl, jsonObject.thumbnailImage.width, jsonObject.thumbnailImage.height);

        return page;
    }

    createEmptyPage(pageToMock): Page {

        const page = new Page();
        page.id = pageToMock.id;
        page.index = pageToMock.index;

        page.image = Image.createImage(`https://${this.applicationStateService.domain}/assets/img/empty.jpg`,
            pageToMock.image.width, pageToMock.image.height);
        page.zoomImage = Image.createImage(`https://${this.applicationStateService.domain}/assets/img/empty.jpg`,
            pageToMock.zoomImage.width, pageToMock.zoomImage.height);
        page.thumbnailImage = Image.createImage(`https://${this.applicationStateService.domain}/assets/img/empty.jpg`,
            pageToMock.thumbnailImage.width, pageToMock.thumbnailImage.height);

        return page;
    }
}
